var pid;
if (typeof process === 'undefined') {
  pid = '';
} else {
  pid = process.pid ? process.pid.toString(36) : '';
}
var _now = function now() {
  var time = Date.now();
  var last = _now.last || time;
  _now.last = time > last ? time : last + 1;
  return _now.last;
};
var composeID = function composeID(prefix) {
  return (prefix ? prefix : '') + pid + _now().toString(36);
};
export default function generateID() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unique_id_';
  return "".concat(composeID(prefix));
}